import React from 'react';
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import CardFull from "./card.full";
import CardFullSkeleton from "./card_full_skeleton";
import {isEmpty} from "../../helpers/helpers";

const SwiperPropertiesCard = ({properties, cartClassName, handleShowProperty = false, freeMode = false, isBadeSaba = false, breakpoints}) => {

    if (isEmpty(breakpoints)) {
        breakpoints = {
            1024: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 2.4,
            },
            320: {
                slidesPerView: 1.4,
            }
        };
    }

    return (
        <Carousel breakpoints={breakpoints} freeMode={freeMode}>
            {
                (properties.length) ?
                    properties.map((property, key) =>
                        <CarouselItem key={key}>
                            <CardFull
                                isBadeSaba={isBadeSaba}
                                className={cartClassName}
                                handleShowProperty={handleShowProperty}
                                property={property}
                            />
                        </CarouselItem>
                    )
                    :
                    [...Array(4)].map((key) =>
                        <CarouselItem key={key}>
                            <CardFullSkeleton/>
                        </CarouselItem>
                    )
            }
        </Carousel>
    );
};

export default React.memo(SwiperPropertiesCard);
